import { useState, useEffect } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

const useUserAnnualTarget = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedCompanies, selectedAccountExecutive } = filterParams;
    const [totalAnnualTarget, setTotalAnnualTarget] = useState(0);
    const { getData, isLoading } = useAxios();

    useEffect(() => {

        const fetchUserTarget = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;

            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus , selectedAccountExecutive, selectedCompanies });

            try {
                const response = await getData(
                    `${baseUrl.annualTargetTotal}?${query}`
                );
                if (response?.success) {
                    setTotalAnnualTarget(response.data?.totalAnnualTarget || 0);
                }
            } catch (err) {
                console.error("Failed to fetch inactive companies", err);
                setTotalAnnualTarget(0);
            }
        };

        fetchUserTarget();
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies]);

    return {
        totalAnnualTarget,
        annualTargetLoading:isLoading,
    };
};

export default useUserAnnualTarget;